/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloudAccountMiniUpdate
 */
export interface CloudAccountMiniUpdate {
    /**
     * 
     * @type {string}
     * @memberof CloudAccountMiniUpdate
     */
    provider?: CloudAccountMiniUpdateProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountMiniUpdate
     */
    name: string;
}

/**
* @export
* @enum {string}
*/
export enum CloudAccountMiniUpdateProviderEnum {
    Azure = 'azure',
    Aws = 'aws',
    Backblaze = 'backblaze',
    Gcloud = 'gcloud'
}

export function CloudAccountMiniUpdateFromJSON(json: any): CloudAccountMiniUpdate {
    return CloudAccountMiniUpdateFromJSONTyped(json, false);
}

export function CloudAccountMiniUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloudAccountMiniUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'name': json['name'],
    };
}

export function CloudAccountMiniUpdateToJSON(value?: CloudAccountMiniUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider': value.provider,
        'name': value.name,
    };
}


